import Vue from 'vue'
import Vuex from 'vuex'
import { SET_USER } from './types'
// import { BaseUtil } from '@zkwq/business'
import {getSession} from '../util/login'
import { CACHE_KEY } from '../constant'

Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        user: getSession(CACHE_KEY.USER_INFO)
    },
    mutations: {
        [SET_USER] (state, user) {
            state.user = user
        }
    },
    actions: {
    },
    modules: {
    }
})
